import {useTranslation} from "react-i18next";
import React, {Suspense} from "react";

import HelmetTagsComponent from "../components/helmet-tags";
import SectionWelcome from "../components/sections/welcome";
import SectionAbout from "../components/sections/about";
import SectionBlog from "../components/sections/blog";
import {Link} from "react-router-dom";

const Main = React.lazy(() => import("../components/sections/main"));
const Services = React.lazy(() => import("../components/sections/services"));
const StackTechnologies = React.lazy(() => import("../components/sections/stack-technologies"));
const Portfolio = React.lazy(() => import("../components/sections/portfolio"));
const Products = React.lazy(() => import("../components/sections/products"));
const Information = React.lazy(() => import("../components/sections/qa"));

function PageHome() {

    const { t, i18n } = useTranslation();

    // TODO: add lazy load with props https://www.memberstack.com/blog/lazy-loading-react-components-react-lazy-react-suspense

    /* SECTIONS:

        into
        ? services
        stack
        portfolio
        ? clients
        products
        ? blog
        info
        ...
    */

    return (
        <div className="home-page">

            <HelmetTagsComponent
                title={t('my.name')}
            />

            {/*<SectionWelcome />*/}

            <Suspense fallback={<div>Loading...</div>}>
                <Main />
            </Suspense>

            {/*<div className={'container p-5'}>*/}
            {/*    <h2>I can help you with ...</h2>*/}
            {/*    <p>*/}
            {/*        services*/}
            {/*    </p>*/}
            {/*</div>*/}

            <Suspense fallback={<div>Loading...</div>}>
                <Services
                    title={t('nav.services')}
                    subTitle={t('subTitle.services')}
                />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <StackTechnologies />
            </Suspense>

            {/*<Suspense fallback={<div>Loading...</div>}>*/}
            {/*    <Portfolio />*/}
            {/*</Suspense>*/}

            <Suspense fallback={<div>Loading...</div>}>
                <Products />
            </Suspense>

            {/*TODO: Blog and Partners add to final release*/}

            {/*<SectionBlog />*/}

            {/*<SectionPartners />*/}

            {/*<SectionAbout />*/}

            {/*<div className={'container p-5'}>*/}
            {/*    <h2>Let’s work*/}
            {/*        together</h2>*/}
            {/*    <p>*/}
            {/*        email + phone + btn on cooperation page*/}
            {/*    </p>*/}
            {/*</div>*/}

            {/*<Suspense fallback={<div>Loading...</div>}>*/}
            {/*    <Information />*/}
            {/*</Suspense>*/}

            <div className="container d-flex flex-wrap-reverse align-items-center justify-content-between vh-50 pt-5 pb-5">

                <div className="col-md-8 col-12 d-flex flex-column align-items-start justify-content-center">

                    <h2  className={'opacity-25'}>

                    </h2>
                    <h2 className={'display-3'}>
                        Ready to build something great?
                    </h2>
                    <p className="subtitle mt-3">
                        Let's set up a cel to ciscuss your requirments
                    </p>
                    <Link to={'/cooperation'} className={'btn btn-dark rounded-pill p-3 mt-3 w-50'}>Contact me </Link>

                </div>

                <div className="col-md-4 col-12">
                    <img src="/assets/photo/8.jpeg" alt="Yaroslav Lukyanchuk" className={'img-fluid rounded-5'}/>
                </div>

            </div>

        </div>
    );
}

export default PageHome;
